import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, interval, startWith } from 'rxjs';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  private updateCheckSubscription?: Subscription;
  private versionUpdatesSubscription?: Subscription;
  private isInitialized = false;

  constructor(private swUpdate: SwUpdate, private snackBar: MatSnackBar) {

  }

  checkForUpdates() {
    // Prevent multiple initializations
    if (this.isInitialized) {
      console.log('Update service already initialized - skipping');
      return;
    }

    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker not enabled');
      return;
    }

    this.isInitialized = true;
    console.log('Initializing update service');

    this.startUpdateChecks();

    // Listen for available updates
    this.versionUpdatesSubscription = this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe((evt) => {
        console.log('New version available');
        const snackBarRef = this.snackBar.open(
          'Refresh to get the latest from detamoov. You\'re running an outdated version.',
          '↻',
          {
            duration: undefined, // Stay open until user acts
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          }
        );

        snackBarRef.onAction().subscribe(() => {
          window.location.reload();
        });
      });
  }
  

  private startUpdateChecks() {
    // Check immediately, then every 60 seconds
    this.updateCheckSubscription = interval(60000).pipe(
      startWith(10000) // Emit immediately, then every 60 seconds
    ).subscribe(() => {
      const timestamp = new Date().toISOString();
      console.log(`[${timestamp}] Checking for updates...`);
      
      this.swUpdate.checkForUpdate().then((updateFound) => {
        console.log(`[${timestamp}] Update check complete`);
      }).catch(err => {
        console.log(`[${timestamp}] Error checking for updates`);
      });
    });
  }

  // Optional: method to manually stop checks (for testing)
  stopChecks() {
    console.log('Stopping update checks');
    this.updateCheckSubscription?.unsubscribe();
    this.versionUpdatesSubscription?.unsubscribe();
    this.isInitialized = false;
  }
}